import styled from 'styled-components';

export const ContextualDataVariablesStyled = styled.div`
  padding: 8px 0;
  
  .mastercardVariables,
  .circanaVariables,
  .wardemVariables {
    &__title {
      font-size: ${props => props.theme.fontSizeXS};
      color: ${props => props.theme.uiColors.textBodyDefault};
    }
    
    &__container {
      background-color: ${props => props.theme.uiColors.contextCreatorBackground};
    }
    
    &__inputs {
      display: inline-flex;
      width: 100%;
      font-size: ${props => props.theme.fontSizeXS};
      
      &Selector {
        width: 70%;
        margin-right: 10px;
        font-size: ${props => props.theme.fontSizeXS};
      }
      &Bill {
        width: 30%;
        font-size: ${props => props.theme.fontSizeXS};
      }
    }
  }
  .circanaVariablesBox,
  .wardemVariablesBox {
    .boxHeader {
      border-radius: 6px;
    }
  }
`;
